// src/components/translations.js
export const translations = {
  fr: {
    AcceptCGUAndRGPD: "J’ai lu et j’accepte les CGU et la politique RGPD",
    Actions: "Actions",
    ActiveGroups: "Groupes actifs",
    ActivePeriod: "Aucune période active — veuillez en créer une.",
    Activity: "Activité",
    ActivePlan: "Forfaits actifs",
    Add: "Ajouter",
    AddOneGroupQuota: "Ajouter un groupe supplémentaire",
    AddANewBlock: "Ajouter un menu personnalisé",
    AddAnItem: "Ajouter un article",
    AddContact: "Ajouter le contact",
    AddContactMsg: "Ajouter des contacts ou demander aux contacts de s'inscrire aux dates proposées",
    Add5Contacts: "Ajouter 5 contacts",
    Add5ContactsToGroup: "Ajouter 5 contacts au groupe",
    AddCreator:"Ajouter le créateur aux contacts",
    AddCreatorToContactsList:"Ajouter le créateur à la liste des contacts",
    All:"Tout",
    AllowUsersToParticipate:"Autoriser les utilisateurs à participer et à modifier les menus",
    NotAllowUsersToParticipate:"Les utilisateurs ne peuvent pas participer et modifier les menus",
    AdminAndUserPasswordMustBeDifferent: "Les mots de passe administrateurs et utilisateurs doivent être différents",
    AddPeriod: "Ajouter une période",
    AdminDashboard: "Tableau de bord administrateur",
    AdminMustChooseOne: "L'administrateur doit choisir une periode",
    AdminNotificationDisabled: "Notification par mail désactivée",
    AdminOnlyAction: "Action réservée à l'administrateur",
    AdminPassword: "Mot de passe administrateur",
    AdminRole: "L’ORGANISATEUR renseigne les contacts, propose les dates et crée les menus.",
    AdminWillBeNotified: "Notification par mail activée",
    AnImageIsAlreadySavedForThisGroup: "Une image est déjà enregistrée pour ce groupe",
    Aperitif: "Apéro",
    
    AverageLifespanOfTheGroups: "Durée de vie moyenne des groupes",
    Beverage: "Boisson",
    BlockDeleted: "Bloc supprimé avec succès",
    BlocName: "Divers pour station musicale, serviettes...",
    BothDatesRequired: "Les deux dates sont requises",
    Cancel: "Annuler",
    CancelEndSurvey: "Annuler la fermeture",
    CannotFixSurvey: "Ajouter des contacts pour voter et fermer le sondage!",
    Category:"Categorie",
    Category_Sucré: "Sucré",
    Category_Salé: "Salé",
    Category_Boisson: "Boisson",
    Category_Apéro: "Apéro",
    Category_Entrée: "Entrée",
    Category_Plat: "Plat",
    Category_Dessert: "Dessert",
    ChoiceAdmin: "Créer un groupe pour inviter les participants ou connecte toi !",
    ChooseFile: "Choisir une image",
    ChooseThisOption: "Choisir cette option",
    ChooseWhatsAppGroupToVote:"Choisir le groupe WhatsApp pour le message de participation au vote",
    Close:"Fermer",
    ComingSoon: "à venir",
    CollapseAll:"Tout plier",
    COMPTA: "Compta",
    ComptaAdmin: "COMPTABILITÉ : Gérer les comptes pour la location",
    ComptaUsers: "COMPTABILITÉ : Consulter les comptes",
    Confirm: "Confirmer",
    ConfirmDeleteBlockText: "Le menu personnalisé disparaitra de la liste des courses",
    ConfirmDeleteBlockTitle: "Confirmer la suppression du menu personnalisé",
    ConfirmDeleteGroup: "Cette action est irréversible et vous perdez l'utilisation de votre groupe",
    ConfirmDeleteGroupTitle: "Confirmez la suppression définitive du groupe et de toutes les données",
    ConfirmDeleteSavedItem: "Suppression de l'article",
    ConfirmDeleteTitle: "Confirmer la supression",
    ConfirmEndOfSurvey: "Confirmer la fin du sondage",
    ConfirmLockSurveyTitle: "Confirmer la mise à jour de la liste des courses",
    ConfirmLockSurveyMessage: "Fermeture du sondage. Direction les menus ! Souhaitez-vous continuer ?",
    ConfirmSurveyCancellation: "Confirmer l'annulation de la fermeture du sondage",
    ConnectToAGroup: "Se connecter à un groupe",
    ConnectOrCreate: "Connectez-vous à un groupe ou créez-en un nouveau",
    ConsiderEntendingIt: "Penser à le prolonger",
    CONTACTS: "1. RENSEIGNER LES CONTACTS",
    ContactAdded: " ajouté !",
    ContactAdmin: "CONTACTS: Ajouter les participants, lier mon groupe WhattApp ou demandez leurs de s'inscrire une fois les dates proposées",
    Contacts: "Contacts",
    ContactsDeleted: "Contacts supprimés",
    ContactUsers: "CONTACTS : Consulter la liste des participants",
    CopyAllEmails: "Copier les emails des participants",
    CopyEmailAddress:"Copier l'adresse e-mail",
    CountryCode: "Code pays",
    CopyEmails: "Copier les emails de la periode dominante",
    CreatorAdded:"Créateur ajouté",
    CreatorAddFailed:"Echec à l'ajout du créateur",
    CreateANewGroup: "Créer un nouveau groupe",
    CreateWhatAppGroupAndAddNumbers: "Créez le groupe et ajoutez ces numéros",
    CreateNewGroup: "Créer un nouveau groupe",
    CreateOrChooseAGroupToManageContacts: "Créez ou choisissez un groupe pour gérer les contacts.",
    CreateWhatsAppGroup: "Créer le groupe WhatsApp avec les contacts de la date gagnante",
    CreateYourMenus: "2. Créer les menus",
    Creation: "Création",
    CreatorMail: "Email du créateur",
    CreatorTel: "Téléphone du créateur",
    CurrentSubscription: "Abonnement actuel: ",
    Date1: "Date 1",
    Date2: "Date 2",
    DailyMenu: "Menu du jour",
    DayPerEvent: "Jour(s) par évènement",
    DayShort: "jour(s)",
    Del: "SUPPRIMER",
    Delete: "Supprimer",
    DeleteBlock: "Effacer le menu personnalisé",
    DeleteGroup: "Effacer le groupe définitivement",
    DeleteGroupFailed: "Échec lors de la suppression du groupe",
    DeleteImage: "Supprimer l'image",
    DeleteItSoYouCanUploadANewOne: "Supprime-la pour pouvoir en téléverser une nouvelle",
    DeleteLast: "Supprimer la dernière",
    DeleteMenuFailed: "Impossible de supprimer le menu associé à cette période",
    DemoVideo: " Vidéo démo",
    Dessert: "Dessert",
    Display: "Afficher",
    Duration: "Durée",
    DuplicateUserError:"Cet email ou ce numéro de telephone est déjà utilisé pour un autre groupe, vous pouvez choisir un abonnement",
    Email: "Mail",
    EmailsAvailable: "email(s) valide(s)",
    EmailsAvailableToCopy: "email(s) à copier",
    EmailsCopied: "Mail(s) copié(s)",
    EmailOptional:"Email (facultatif)",
    EmailSent: "mail envoyé ! Pensez à fournir le mot de passe utilisateurs aux participants",
    EmailAlreadyTaken:"Cet email est déja utilisé, connectez-vous pour choisir un abonnement",
    EmojiTheme: "Thème Emoji",
    EmptyShoppingList: "Créer les menus pour remplir la liste de courses",
    EmptyInfosMapUser:"Le lieu de l'évènement sera bientôt indiqué!",
    EmptyListeUsersMsg:"La liste de course se remplie automatiquement en fonction des menus",
    EmptyInfosMapAdmin:"Ajoutez un lien web ou une image pour indiquer le lieu de l'évènement",
    EndDateAfterStart: "La date de fin doit être après la date de début.",
    EnterEmailManually: "Saisir le(s) adresse(s) e-mail(s) manuellement",
    EnterInformationToParticipateInSurvey:"Entrez vos informations pour participer au sondage.",
    EnterWhatsAppGroupLink:"Entrez le lien d’invitation de votre groupe WhatsApp.",
    ErrorCopyingEmails: "Erreurs lors de la copie des e-mails",
    ErrorDuringValidation: "Erreur lors de la validation",
    ErrorLockingSurvey: "Erreur lors du verrouillage",
    ErreurOccuredAddingContact: "Une erreur est survenue lors de l'ajout du contact.",
    ErrorSendingEmail: "Erreur lors de l'envoi",
    Essential: "Essentiel",
    EssentialSubscription: "Abonnement Essentiel",
    Evening: "Soir",
    ExistingGroup: "Ce nom de groupe est déjà utilisé. Choisissez-en un autre.",
    Extend: "Prolonger le groupe",
    ExtendContacts: "Augmenter le nombre d'invités",
    ExpandAll:"Tout déplier",
    ExtendFor1MonthsFree: "Prolonger gratuitement mon essai de 1 mois",
    ExtendOrAddAGroup:"Prolonger ou ajouter un groupe",
    Free: "Gratuit",
    FreeGroups: "Groupes gratuits",
    FreeGroupsActives: "Groupes gratuits actifs",
    FreeGroupsInactives: "Groupes gratuits inactifs",
    FreeGroupsSimples: "",
    HowManyPeople:"Combien de personne(s) ?",
    QuotaNotDefined:"Quota non défini",
    RGPDGeneralTerms:"Conditions Générales d’Utilisation (CGU) & Politique RGPD",
    RGPDAcceptUseConditions:"En utilisant cette application, vous acceptez les présentes conditions générales d’utilisation. Ce service est destiné à faciliter la gestion de groupes, la transmission d’informations et l’organisation de listes partagées.",
    RGPD1PersonalDataProtection:"1. Protection des données personnelles (RGPD)",
    RGPDDataProtectionRegulationRules:"Conformément au Règlement Général sur la Protection des Données (RGPD), nous collectons uniquement les données nécessaires à la création et à la gestion de votre groupe (nom, email, téléphone). Ces données ne sont jamais revendues et sont conservées de manière sécurisée.",
    RGPDPurposeCollection:" 2. Finalité de la collecte",
    RGPDDataUtilization:"Les données sont utilisées pour : créer un groupe, gérer les accès, envoyer des emails liés aux listes, et permettre la personnalisation (emoji, couleur, etc.).",
    RGPDUsersRights:"3. Droits des utilisateurs",
    RGPDUsersContacts:"Vous pouvez à tout moment demander l’accès, la rectification ou la suppression de vos données en nous contactant via l’adresse indiquée dans l’application.",
    RGPDResponsibility:"4. Responsabilité",
    RGPDUsersResponsibility:"L’utilisateur est responsable du contenu qu’il saisit et partage. L’éditeur ne saurait être tenu responsable d’un usage détourné ou frauduleux par un tiers.",
    RGPD5Modifications:" 5. Modifications",
    RGPDModificationschecks:"Ces CGU peuvent être mises à jour à tout moment. L’utilisateur est invité à les consulter régulièrement.",
    GoToMenus: "Aller aux Menus",
    GoToSurvey: "Aller au sondage",
    GroupAlreadyUsedRGPD: "Groupe d'essai gratuit utilisé",
    Group: "Mon groupe",
    GroupsOnly: "Groupe",
    Group1Contacts15: "1 groupe, 20 contacts",
    Group1Contacts20: "1 groupe, 20 contacts",
    Group1Contacts30: "1 groupe, 30 contacts",
    Group1Contacts30For12Months: "1 groupe, 30 contacts",
    Group5Contacts30Monthly: "Mensuel - 5 groupes, 30 contacts",
    Group1Contacts20For12Months: "1 groupe, 20 contacts",
    GroupByOrganizer: "Groupe par organisateur",
    GroupConnection: "Connexion au groupe",
    GroupeOneQuotaReached: "Quota atteint : vous avez déjà créé un groupe. Réactivez-le ou passez à un abonnement",
    GroupCreate: "Creer le groupe",
    GroupCreatedSuccessfully: "Groupe crée avec succès ",
    GroupCreatedThisMonth: "Groupe crées ce mois ci",
    GroupCreation: "Creer un groupe",
    GroupDeleted: "Groupe supprimé avec succès",
    GroupDeletedOrFrozen: "Le groupe a été utilisé puis supprimé, vous pouvez choisir un autre forfait",
    GroupDelDashboard: "Groupe(s) supprimé(s)",
    GroupExpirationDate: "Ce groupe expire le ",
    GroupExtensionFreeUsed: "Ce groupe a déjà bénéficié d’une prolongation gratuite. Toute nouvelle extension nécessite un abonnement.",
    GroupExtendedSuccessfully: "🎉 Votre groupe a été prolongé.",
    GroupFreeTrialUsedWithThisEmail: "Vous avez déjà utilisé votre essai gratuit.Veuillez prolonger ou souscrire.",
    GroupFromQuotaExtension: "Groupe issu de l'extension de quota",
    GroupModificationDesactivated: "Le sondage est clôturé - modification du groupe désactivée.",
    GroupName: "Nom du groupe",
    GroupNameAlreadyUsed: "Ce nom est déjà utilisé. Veuillez en choisir un autre",
    GroupNameModificationImpossible: "Impossible de modifier le nom du groupe",
    GroupNameALreadyInUse: "Ce nom de groupe est déjà utilisé.",
    GroupNumber: "Groupe: ",
    GroupNotFound: "Groupe introuvable",
    GroupOptions: "Options pour le groupe: ",
    GroupPerMonth: "Groupe(s) par mois",
    GroupUpdated: "Groupe mis à jour",
    Hello: "Bonjour vous",
    Hide: "Masquer",
    Home: "Accueil",
    HowManyPeople: "Combien de personne",
    IParticipate:"Je participe",
    ImageDeleted: "Image effacée",
    ImageSavedForGroup: "Image enregistrée pour le groupe",
    ImpossibleAddParticipation:"Impossible d’ajouter votre participation. Veuillez contacter l’administrateur du groupe.",
    ImportFromContacts: "Importer depuis les contacts",
    ImportFromMobile: "Importer les contacts du mobile",
    ImportContactsNotSupported:"Importation des contacts non prise en charge",
    ImportYourContactsToSendTheSurvey: "1. Renseigner les contacts pour envoyer le sondage",
    Identifier: "Identifiant",
    InvalidEmailFormat: "Format de mail invalide",
    InvalidPhoneFormat: "Format de numéro de téléphone invalide",
    Item: "Article",
    ItemCreated: "Article crée",
    ItemDeleted: "Article effacé",
    ItemRequired: "Article requis",
    IncorrectNameOrPassword: "Nom ou mot de passe incorrect",
    Information: "Information",
    InfosAdmin: "LIEU DE L'ÉVÈNEMENT : Ajoute une photo ou un lien du lieu de l'évenement",
    InfosMap: "Lieu de l'évènement",
    InfosUsers: "LIEU DE L'ÉVÈNEMENT",
    ItemAlreadyExists:"L'élément existe déjà",
    IntroFree: "Prolonger gratuitement votre période d'essai",
    Intro3Months: "Pour une soirée entre ami(e)s...",
    Intro6Months: "Un anniversaire, un enterrement de vie de jeune fille...",
    Intro12Months: "Une cousinade, une fête de famille ?! ",
    IntroEssential: "Les as de l'organisation, 5 groupes en même temps !!!  ",
    IntroGroupPlus1: "Ajoutez un groupe supplémentaire avec 30 contacts",
    Intro20Contacts: "Une soirée, un anniversaire, une cousinade, une fête de famille ?! C'est parti !",
    IntroAdd5Contacts:"Ajouter 5 invités",
    LandingTitle:"OrganiZwk\nOrganiser les weekends facilement",
    LandingDescription:"Créer ton groupe, proposer des dates, imaginer les menus et partager la liste ! ",
    LandingSEO_Title:"OrganiZwk – Organisez vos soirées, week-ends et événements facilement",
    LandingSEO_Description: "OrganiZwk facilite l’organisation de vos événements : gestion des contacts, choix de la date, création des menus, liste des articles à apporter et centralisation de toutes les informations.",
    LastNameFirstName:"Nom Prénom",
    LinkSavedSuccess: "Lien sauvegardé avec succès",
    LinkDeletedSuccess: "Lien effacé avec succès",
    LinkWhatsAppGroup:"Lier mon groupe WhatsApp",
    LIST: "4. PARTAGER LA LISTE DES COURSES",
    List: "Liste de courses",
    LinkSaved: "Lien enregistré",
    
    ListeAdmin: "LES COURSES : Envoyer la liste aux participants",
    ListeUsers: "LES COURSES : Remplir la liste de courses",
    Loading: "Chargement...",
    locale: "fr-FR",
    LogIn: "Se connecter",
    LogOut: "Se deconnecter",
    MainCourses: "Plat",
    MenuUpdated: "Menu mis à jour",
    Morning: "Matin",
    Matin: "Matin", 
    Midi: "Midi", 
    NewGroup20Contacts:"Nouveau groupe avec 20 contacts",
    Soir: "Soir", 
    Sucré: "Sucré", 
    Salé: "Salé", 
    Boisson: "Boisson", 
    Apéro: "Apéro", 
    Entrée: "Entrée", 
    Plat: "Plat", 
    Dessert: "Dessert",
    MailAddrCopied:"Adresse e-mail copiée ✓",
    MaxParticipantsReached:"Le nombre maximum de participants a été atteint. Veuillez contacter l’administrateur du groupe.",
    MaxPeriodExceeded: "La période ne doit pas dépasser 7 jours.",
    ManageYourGuests: "1.Importe et gère tes contacts",
    MENUS: "3.CREER LES MENUS",
    Menus: "Menus",
    MenusAdmin: "LES MENUS : Créer les menus pour chaque jours",
    MenuCreationFollowingWinningDates: "Création des menus. ",
    MenusUsers: "LES MENUS : Consulter les menus par jours",
    MenuUnavailableDataMissing: "Menu indisponible - Données manquantes",
    ModifyGroupName: "Modifier le nom du groupe",
    ModifyPeriod: "Créer, ajouter, modifier les dates",
    Moment_Matin: "Matin",
    Moment_Midi: "Midi",
    Moment_Soir: "Soir",
    Monthly: "Mensuel",
    MonthlyUnlimited: "Mensuel illimité",
    Months: "mois",
    Months3: "3 mois",
    Months12: "12 mois",
    Morning: "Matin",
    MultipleDominantPeriods: "Plusieurs periodes dominantes",
    MyGroup: "Mon groupe",
    Name: "Nom",
    NameAlreadyUsed:"Ce nom est déja utilisé, veuillez en choisir un autre",
    NaturalDominantePeriodUsed: "La date avec le plus de participants est utilisée",
    NewAdminPassword: "Nouveau mot de passe admin",
    NewSuffix: "nouveau",
    NewUsersPassword: "Nouveau mot de passe utilisateurs",
    NoAccountingRecordsFoundForThisGroup: "Aucun enregistrement comptable trouvé pour ce groupe.",
    NoActiveDays: "Fermer le sondage en cours pour créer les menus et indiquer la liste des éléments à apporter!",
    NoActiveDaysUser:"Le sondage doit être fermé par l'administrateur pour la création des menus",
    NoCustomBlocksYet: "Aucun bloc personnalisé pour l'instant",
    NoExpirationDefined: "Aucune date d'expiration définie",
    NoGroupSelected: "Pas de groupe séléctionné",
    NoImagesSavedForThisGroup: "Aucune image enregistrée pour ce groupe",
    NoItemYet:"Aucun article pour le moment",
    NoPeriodDefinedAddOrCreateOneToStart: "Aucune période définie. Créez, ajoutez ou modifiez des dates pour commencer.",
    NoPeriodValidated: "Aucune période validée",
    NoTheme: "Aucun thème",
    NoticeQuotaUsedAndGroupDeleted:"Votre quota est utilisé et vous avez un groupe supprimé",
    Noon: "Midi",
    NotifyAdminOnSurveyFill: "Recevoir un mail lorsque tous les participants ont voté (fonctionnalité à venir)",
    NoValidEmail: "Aucun email",
    NoValidEmailToCopy: "Aucun email à copier",
    NoValidPhone: "Aucun numéro valide",
    NumberOf: "Nombre de ",
    NumberOfDays: "Nombre de jour(s)",
    OktoGo: "Vous confirmer ?",
    OpenWhatsApp:"Ouvrir WhatsApp",
    Organizers: "Organisateurs",
    OrganiZwk: "organiZwk, l'application qui t'aide à organiser ton évènement !",
    Package3Months: "Forfait 3 mois",
    Package6Months: "Forfait 6 mois",
    Package12Months: "Forfait 12 mois",
    PackageEssential: "Forfait essentiel",
    PackageRequired:"Forfait requis",
    Package20Contacts:"Forfait 20 contacts",
    PageListLinkSentError: "Erreur lors de l'envoi du lien de la liste",
    PageListLinkSentSuccess: "Lien de la liste envoyée avec succès",
    Participants: "Participants",
    ParticipantsPerGroup: "Participant(s) par groupe",
    Participate:"Participer",
    Party: "Lieu l'évènement",
    Password: "Mot de passe",
    PasswordsMustDiffer: "Les mots de passe doivent être différents",
    PasswordReinit: "Réinitialisation des mots de passe",
    PasswordReset: "Mots de passe réinitialisés !",
    PasswordsSentToAdminEmail: "Mot de passe envoyé à l'organisateur",
    Payment1: "Virement 1",
    Payment2: "Virement 2",
    People: "Personne(s)",
    Period: "Période: ",
    PleaseWaitBeforeSendingAgain:"mail(s) envoyé(s), veuillez patienter avant de renvoyer.",
    PleaseWaitWakeUp: "Un instant… je me réveille 🥱",
    AuthorizedPeriods: "Périodes autorisée(s) ",
    Participation:"+ Je participe",
    Phone: "Telephone",
    PhoneAlreadyUsed: "Ce numero de téléphone est utilisé pour un autre groupe, vous pouvez vous connecter et prendre un forfait",
    PhoneNumber: "Numéro de téléphone",
    Plan: "Planifiez, Partagez, Profitez",
    "PlanLabel.forfait3": "Forfait 3 mois",
    "PlanLabel.forfait6": "Forfait 6 mois",
    "PlanLabel.forfait12": "Forfait 12 mois",
    "PlanLabel.essentiel": "Formule Essentielle",
    "PlanLabel.groupePlus1": "1 groupe supplémentaire",
    "PlanLabel.gratuit": "Essai gratuit",
    PlanShareEnjoy: "Planifiez l'évènement, Partagez la liste de course, et profitez de la fête avec l'application organiZwk 🍽️",
    PleaseEnterAGroupName: "Veuillez entrer un nom de groupe.",
    Premium: "Premium",
    PremiumSubscription: "Abonnement Premium",
    Print:"Imprimer",
    PrintFor: "Liste pour ",
    PrintThisDay: "Les menus du jour",
    Quantity: "Quantité",
    Qte: "Qté",
    QuantityRequired: "Veuillez indiquer une quantité",
    QuotaReached:"Votre quota est atteint, vous pouvez choisir d'utiliser un autre groupe ou prendre un forfait.",
    QuotaContactsReached: "Quota de contacts atteint. Supprimez un contact ou passez à une offre supérieure.",
    RecoverMyContacts: "Récuperer mes contacts",
    ReactivateExistingGroup: "Réactiver le groupe existant",
    RealTime: "Temps réel",
    ReadRules: "Voir les règles",
    RemoveLink: "Supprimer le lien",
    ShareListWhatsApp:"Envoyer la liste sur WhatsApp",
    ShareSurveyWhatsApp:"Partager le sondage dans WhatApp",
    SearchContact: "Rechercher un contact...",
    ScrollRight: "Faire défiler",
    RowsPerPageShort:"Lignes: ",
    SamePasswordWarning: "Les mots de passe Administrateur et utilisateurs ne doivent pas être identiques",
    Save: "Enregistrer",
    SaveImage: "Sauvegarder l'image",
    SavePeriods: "Enregistrer les périodes",
    SavePeriodFailed: "Impossible d'enregistrer les périodes",
    SaltyItem: "Salé",
    SearchGroups: "Rechercher le(s) groupes(s)",
    SeeDemo:"Voir La démo",
    SeeReactivationOrSubscritpionOptions: "Voir les options de réactivation",
    selectLanguage: "Choisir la langue",
    SelectedPeriod: "Date sélectionnée, du : ",
    SendShoppingListSMS: "Envoyer la liste par SMS",
    SendMail: "Envoyer un mail à tous les contacts pour participer au sondage",
    SendSMS: "Envoyer un SMS aux participants",
    SendSurveySMS: "Envoyer le sondage par SMS",
    ServerError: "Erreur serveur.",
    SeparateMultipleEmailsWithComma: "Séparer les mails par une virgule",
    ShowCards: "Cartes",
    ShowTable: "Tableau",
    SpecialPackagesAndGroups: "Forfaits et groupes spéciaux",
    PhonesAvailable: "numéro(s) valide(s)",
    SendPageListLink: "Envoyer la liste par mail",
    SendPasswordsByEmail: "Lien de reinitialisation des mots de passe envoyé à l'administrateur",
    SendSMS: "SMS ",
    SendSMSFor: "SMS pour",
    SendSurveyEmail: "Envoyer le sondage par mail",
    SeveralPeriodsTied: "Plusieurs périodes sont ex æquo. Choisissez celle à privilégier :",
    share: "Partager",
    ShoppingList: "Voir et partager la liste de courses",
    ShowColumnsFor: "Montrer les colonnes pour",
    SMSAppOpened: "SMS envoyé(s) ! Pensez à fournir le mot de passe utilisateurs aux participants",
    SMSInvitationMessage: "Bonjour, \n\nMerci de remplir le sondage en indiquant le nombre de personnes présentes aux dates proposées pour déterminer une date d'évènement pour le groupe ",
    SMSShoppingList: "Bonjour, voici la liste des courses",
    StartAdventure:"Creer mon groupe",
    Starter: "Entrée",
    Statistics: "Statistiques",
    SubscribeFor6Months: "S’abonner pour 6 mois",
    SubscribeFor1Year: "S’abonner pour 1 an",
    Subscription: "Abonnement",
    SubscriptionUpdated: "Votre abonnement a été mise à jour. Vous pouvez vous connecter avec les mêmes mots de passe qu’avant.",
    SubscriptionUpdatedWithDuration: "Votre forfait {{duration}} mois est actif.",
    SubscriptionUpdatedWithDuration_one: "Votre forfait {{count}} mois est actif.",
    SubscriptionUpdatedWithDuration_other: "Votre forfait {{count}} mois est actif.",
    SURVEY: "2. ENVOYER LE SONDAGE",
    Survey: "Sondage",
    SurveyAdmin: "SONDAGE: Proposer des dates et lancer le sondage",
    SurveyCompleted: "Sondage fermé",
    SurveyOpen: "Sondage ouvert",
    SurveySuccessValidated: "Sondage validé avec succès, les menus sont crées",
    SurveyLocked: "Sondage vérrouillé. Direction les menus!",
    SurveyLockedContactMessage: "Le sondage est fermé. Vous ne pouvez plus ajouter de contacts.",
    SurveyLockedTooltip: "Le sondage est verrouillé. Impossible de l’annuler.",
    SurveyUnvalidated: "Sondage en cours...",
    SurveyUsers: "SONDAGE: Faire défiler les dates => et remplir le sondage",
    SURVEYTAB: "SONDAGE",
    SweetItem: "Sucré",
    SyncActiveMessage: "Les menus sont mis à jour automatiquement",
    Taken: "Pris",
    TelOptional:"Téléphone (facultatif)",
    TestGroupMessage: "Ce groupe est un groupe d’essai. Vous pouvez le prolonger gratuitement de 1 mois ou choisir un autre forfait.",
    Theme: "Thème",
    TheListIsreadyToBeSHared: "3. Et hop ! la liste de courses est prête à être partagée",
    ThisActionWillDeleteMenusCreated: "Cette action supprimera les menus créés à partir de la période validée !",
    ThisGroupUsesYourAdditionalQuota: "Ce groupe utilise votre quota supplémentaire",
    TipContent:"Choisir un emoji et une couleur pour personnaliser le groupe !",
    TipTitle:"Astuces",
    To: "au",
    Total: "Total",
    TotalVotes: "Total des votes: ",
    TotalQuantityItems:"Total des Items",
    Type: "Type",
    UpdateShoppingList: "Mettre à jour la liste de courses",
    UploadAnImage: "Choisir une image:",
    UserPassword: "Mot de passe utilisateurs",
    UsersRole: "LES UTILISATEURS votent pour les dates et participent à la liste de courses.",
    UnableToCreateGroup: "Impossible de créer le groupe.",
    UnvalidateFailed: "Erreur lors de la dévalidation",
    UnvalidateSuccess: "Période dévalidée avec succès, les menus sont effacés",
    Validate: "Valider",
    ValidateEndOfSurvey: "Fermer le sondage",
    ValidPhoneNumber: "numéro à copier",
    ValidPhoneNumbers: "numéros",
    ValidUntil: "Valable jusqu'au",
    ViewShoppingList: "Voir la liste des courses",
    Weblink: "Lien internet",
    Welcome: "Bienvenue",
    What: "Quoi",
    YouChooseSpecificPeriod: "Choix de la date ",
    Months3Event: "Evènement 3 mois",
    Months12Event: "Evènement 12 mois",
    WhatsAppGroupName:"Nom du groupe WhatsApp",   
    WhatsAppGroupLink:"Lien d’invitation WhatsApp",
    WhatsAppGroupLinkIndication:"📱 Sur iPhone: ouvrez votre groupe WhatsApp, touchez le nom du groupe, puis choisissez Ajouter « Inviter à rejoindre le groupe via un lien » et « Copier le lien ».",
    WhatsAppSurveyGreeting: "Bonjour",
    WhatsAppSurveyInvitation: "Merci de voter pour indiquer vos disponibilités dans le groupe {{nomGroupe}}. Le mot de passe est :     ",
    WhatsAppListInvitation: "Merci d'indiquer ce que vous apportez dans la liste du groupe {{nomGroupe}}. Le mot de passe est :     ",
    YouHaveReachedYourQuota:"Vous avez atteint votre quota.",
    YourGroupWasDeleted:"Votre groupe précèdent a été supprimé",

  },

  en: {
    AdminDashboard:"Administrator dashboard",
    AcceptCGUAndRGPD:"I have read and accept the T&Cs and the GDPR policy",
    ActiveGroups:"Active groups",
    Actions: "Actions",
    ActivePeriod: "No active period — please create one.",
    Activity:"Activity",
    ActivePlan:"Active plans",
    Add: "Add",
    AddCreator:"Add the creator to the contacts",
    AddANewBlock:"Add a custom menu",
    AddAnItem:"Add an item",
    AddContact: "Add contact",
    AddContactMsg: "Add contacts or ask contacts to register for the proposed dates",
    Add5Contacts: "Add 5 contacts",
    Add5ContactsToGroup: "Add 5 contacts to the group",
    AddCreatorToContactsList:"Add the creator to your contact list",
    AdminAndUserPasswordMustBeDifferent:"Administrator and user passwords must be different",
    AddOneGroupQuota: "Add an additional group",
    AddPeriod:"Add a period",
    All:"All",
    AllowUsersToParticipate:"Allow users to participate in and modify menus",
    NotAllowUsersToParticipate:"Users cannot participate in or modify the menus.",
    AdminMustChooseOne:"The administrator must choose a period",
    AdminNotificationDisabled:"Email notification disabled",
    AdminOnlyAction:"Action reserved for the administrator",
    AdminPassword: "Administrator password",
    AdminRole: "THE ORGANIZER provides contacts, suggests dates and creates menus.",
    AdminWillBeNotified:"Email notification enabled",
    AnImageIsAlreadySavedForThisGroup:"An image is already saved for this group.",
    Aperitif:"Aperitif",
    AverageLifespanOfTheGroups:"Average lifespan of the groups",
    Beverage:"Beverage",
    BlockDeleted: "Custom menu successfully removed",
    BlocName:"Various for music station, napkins...",
    BothDatesRequired:"Both dates are required",
    Cancel: "Cancel",
    CancelEndSurvey:"Cancel closing",
    CannotFixSurvey:"Add contacts to vote and close the poll!",
    Category:"Category",
    Category_Sucré: "Sugar",
    Category_Salé: "Salty",
    Category_Boisson: "Beverage",
    Category_Apéro: "Aperitif",
    Category_Entrée: "Starter",
    Category_Plat: "Main courses",
    Category_Dessert: "Dessert",
    ChooseFile:"Choose an image",
    ChooseThisOption: "Choose this option",
    ChooseWhatsAppGroupToVote:"Choose the WhatsApp group for the vote participation message",
    Close:"Close",
    CollapseAll:"Collapse All",
    CopyEmailAddress:"Copy the email address",
    ComingSoon: "coming soon",
    COMPTA: "ACCOUNTING",
    ComptaAdmin:"ACCOUNTING : manage rental accounts",
    ComptaUsers:"ACCOUNTING : View accounts",
    Confirm:"Confirm",
    ConfirmDeleteBlockText:"The personalized menu will disappear from the shopping list.",
    ConfirmDeleteBlockTitle:"Confirm the deletion of this custom menu?",
    ConfirmDeleteGroup: "This action is irreversible and you will lose access to your group.", 
    ConfirmDeleteGroupTitle: "Confirm the permanent deletion of the group and all data",
    ConfirmDeleteSavedItem:"Deletion of the article",
    ConfirmDeleteTitle:"Confirm deletion",
    ConfirmEndOfSurvey:"Confirm the end of the survey",
    ConfirmLockSurveyMessage:"Survey closed. Let's go to the menus! Do you wish to continue?",
    ConfirmLockSurveyTitle:"Confirm shopping list update",
    ConfirmSurveyCancellation:"Confirm cancellation of survey closure",
    ConnectToAGroup:"Connect to a group",
    ConnectOrCreate:"Connect to a group or create a new one",
    ConsiderEntendingIt:"Consider extending it",
    CONTACTS: "1. FILL IN CONTACTS",
    ContactAdded:" added!",
    ContactAdmin:"CONTACTS: Add participants, link my WhatsApp group, or ask them to register once the dates are proposed.",
    Contacts: "Contacts",
    ContactsDeleted:"Contacts deleted",
    ContactUsers:"View the list of participants",
    CountryCode:"Country Code",
    CopyAllEmails:"Copy participants' emails",
    CopyEmails:"Copy emails from the dominant period",
    CreatorAdded:"Creator added",
    CreatorAddFailed:"Creator addition failed",
    CreateANewGroup:"Create a new group",
    CreateNewGroup: "Create new group",
    CreateOrChooseAGroupToManageContacts: "Create or choose a group to manage contacts.",
    CreateWhatsAppGroup: "Create the WhatsApp group with the contacts of the winning date",
    CreateYourMenus:"2. Create the menus",
    Creation:"Creation",
    CreatorMail:"Creator Email",
    CreatorTel: "Creator's Phone",
    CurrentSubscription:"Current Subscription: ",
    Date1: "Date 1",
    Date2: "Date 2",
    DailyMenu: "Daily menu",
    DayPerEvent:"Day(s) per event",
    DayShort: "day(s)",
    Del: "DEL",
    Delete: "Delete",
    DeleteBlock:"Clear the custom menu",
    DeleteGroupFailed:"Failed to delete the group",
    DeleteImage:"Delete image",
    DeleteItSoYouCanUploadANewOne:"Delete it so you can upload a new one.",
    DeleteLast:"Delete last",
    DeleteMenuFailed:"Unable to delete the menu associated with this period",
    DemoVideo: "Demo video",
    Dessert:"Dessert",
    Display: "Display",
    DuplicateUserError:"This email address or phone number is already in use for another group; you can choose a subscription.",
    Duration:"Duration",
    Email: "Email",
    EmailsAvailable:"Valid email(s)",
    EmailsAvailableToCopy: "email(s) to copy",
    EmailsCopied:"Copied email(s)",
    EmailOptional:"Email (optional)",
    EmailSent:"Email sent! Remember to provide the user passwords to the participants",
    EmailAlreadyTaken:"This email address is already in use. Please log in to choose a subscription.",
    EmojiTheme:"Emoji Theme",
    EmptyShoppingList: "Create menus to fill the shopping list",
    EmptyInfosMapAdmin:"Add a web link or image to indicate the event location.",
    EmptyInfosMapUser:"The location of the event will be announced soon!",
    EndDateAfterStart:"The end date must be after the start date.",
    EnterInformationToParticipateInSurvey:"Enter your information to participate in the survey.",
    EnterEmailManually:"Enter the email address(es) manually",
    EnterWhatsAppGroupLink:"Enter the invitation link for your WhatsApp group",
    ErrorCopyingEmails:"Error copying Emails",
    ErrorDuringValidation:"Error during validation",
    ErrorLockingSurvey:"Error while locking",
    ErreurOccuredAddingContact: "An error occurred while adding the contact.",
    ErrorSendingEmail:"Error sending",
    Essential:"Essential",
    EssentialSubscription:"Essential Subscription",
    Evening:"Evening",
    ExistingGroup: "This group name is already in use. Please choose another one.",
    ExpandAll:"Expand all",
    Extend:"Extend the group",
    ExtendContacts: "Increase the number of guests",
    ExtendFor3MonthsFree:"Extend my 3-month trial for free",
    ExtendOrAddAGroup:"Extend or add a group",
    Free:"Free",
    FreeGroups:"Free groups",
    FreeGroupsActives:"Active free groups",
    FreeGroupsInactives:"Free inactive groups",
    GoToMenus: "Go to Menus",
    GoToSurvey: "Go to the survey",
    GroupsOnly: "Groups",
    GroupAlreadyUsedRGPD:"Free trial group used",
    Group1Contacts15:"1 group, 20 contacts",
    Group1Contacts20:"1 group, 20 contacts",
    Group1Contacts30:"1 group, 30 contacts",
    Group1Contacts30For12Months:"1 group, 30 contacts",
    Group5Contacts30Monthly:"Monthly, 5 groups, 30 contacts",
    Group1Contacts20For12Months: "1 group, 20 contacts",
    GroupConnection:"Group connection",
    GroupeOneQuotaReached:"Quota reached: You have already created a group. Reactivate it or upgrade to a subscription",
    GroupCreate: "Create the group",
    GroupCreatedSuccessfully:"Group successfully created",
    GroupCreatedThisMonth:"Group created this month",
    GroupCreation: "Create a group",
    GroupByOrganizer:"Group by organizer",
    GroupDeleted:"Group successfully deleted",
    GroupDeletedOrFrozen:"The group has been used and then deleted; you can choose another subscription.",
    GroupDelDashboard:"Groups deleted",
    GroupExpirationDate:"This group expires on ",
    GroupExtensionFreeUsed:"This group has already benefited from a free extension. Any further extensions require a subscription.",
    GroupExtendedSuccessfully:"🎉 Your group has been extended.",
    GroupFreeTrialUsedWithThisEmail:"You have already used your free trial. Please extend or subscribe.",
    GroupFromQuotaExtension:"Group From Quota Extension",
    GroupModificationDesactivated:"The poll is closed - group editing disabled.",
    GroupName: "Group name",
    GroupNameAlreadyUsed:"This name is already in use. Please choose another one.",
    GroupNameModificationImpossible:"Unable to change the group name",
    GroupNameALreadyInUse:"This group name is already in use.",
    GroupNumber:"Group: ",
    GroupNotFound:"Group not found",
    GroupOptions:"Group options: ",
    GroupPerMonth:"Group(s) per month",
    GroupUpdated:"Group updated",
    Hide: "Hide",
    Home: "Home",
    HowManyPeople: "How many people ?",
    IParticipate:"I participate",
    ImageDeleted:"Deleted image",
    ImageSavedForGroup:"image saved for the group",
    ImpossibleAddParticipation:"Unable to add your participation. Please contact the group administrator.",
    ImportFromContacts:"Import from Contacts",
    ImportFromMobile:"Import contacts from mobile",
    ImportYourContactsToSendTheSurvey:"1. Fill in the contacts to send the survey",
    ImportFromMobile: "Import contacts from mobile",
    ImportContactsNotSupported:"Contact import not supported",
    IncorrectNameOrPassword: "Incorrect group name or password",
    InvalidPhone: "Numéro de téléphone invalide. Utilisez le format international (+XX...)",
    Identifier:"Identifier",
    Information:"Information",
    InfosAdmin:"EVENT LOCATION: Add a photo or link to the event location",
    InfosMap:"Location of the event",
    InfosUsers:"EVENT LOCATION",
    IntroFree:"Extend your trial period for free",
    Intro3Months:"For an evening with friends...",
    Intro6Months:"A birthday, a bachelorette party...",
    Intro12Months:"A family reunion, a family celebration ?!",
    IntroEssential:"Organizational aces, 5 groups at the same time!!!",
    IntroGroupPlus1: "Add an additional group with 30 contacts",
    Intro20Contacts: "A party, a birthday, a family reunion, a family celebration?! Let's go!",
    IntroAdd10Contacts:"Add guests",
    IntroAdd5Contacts:"Add 5 guests",
    InvalidEmailFormat:"Invalid email format",
    InvalidPhone: "Invalid phone number. Use international format (+XX...)",
    InvalidPhoneFormat:"Invalid phone number format",
    Item:"Item",
    ItemAlreadyExists:"The item already exists",
    ItemCreated: "Item created",
    ItemDeleted:"Item deleted",
    ItemRequired: "Item required",
    LandingTitle:"OrganiZwk - Organize your weekends easily",
    LandingDescription:"Create your group, suggest dates, plan menus and share the list!",
    LandingSEO_Title:"OrganiZwk – Easily organize your parties, weekends and events",
    LandingSEO_Description: "OrganiZwk makes organizing your events easier: managing contacts, choosing the date, creating menus, listing items to bring, and centralizing all information.",
    LastNameFirstName:"Last Name, First Name",
    LIST: "4. SHARE THE SHOPPING LIST",
    List: "Shopping list",
    EmptyListeUsersMsg:"The shopping list is automatically populated based on the menus.",
    LinkDeletedSuccess:"Link successfully deleted",
    LinkWhatsAppGroup:"Link my WhatsApp group",
    LinkSaved:"link saved",
    LinkSavedSuccess:"Link saved successfully",
    ListeAdmin:"SHOPPING LIST : Send the list to participants",
    ListeUsers:"SHOPPING LIST : Fill out the shopping list",
    Loading: "Loading...",
    locale: "en-En" ,
    LogIn: "Log In",
    LogOut:"Log out",
    MailAddrCopied:"Email address copied ✓",
    MainCourses:"Main courses",
    Matin: "Morning",
    MaxParticipantsReached:"The maximum number of participants has been reached. Please contact the group administrator.",
    Midi: "Lunch", 
    NewGroup20Contacts:"New group with 20 contacts",
    Soir: "Dinner", 
    Sucré: "Sweet", 
    Salé: "Savory", 
    Boisson: "Drink", 
    Apéro: "Appetizer", 
    Entrée: "Starter", 
    Plat: "Main course", 
    Dessert: "Dessert",
    ManageYourGuests: "Import and manage you guests",
    MaxPeriodExceeded:"The period must not exceed 7 days.",
    MENUS: "3. CREATE MENUS",
    Menus: "Menus",
    MenuUpdated: "Menu updated",
    MenusAdmin:"MENUS: Create menus for each day",
    MenuCreationFollowingWinningDates:"Creation of menus. ",
    MenuUnavailableDataMissing:"Menu unavailable - Data missing",
    MenusUsers:"THE MENUS : Daily menus",
    ModifyGroupName: "Change the group name",
    ModifyPeriod: "Create, add, modify dates",
    Moment_Matin: "Morning",
    Moment_Midi: "Noon",
    Moment_Soir: "Evening",
    Monthly:"Monthly",
    MonthlyUnlimited:"Monthly unlimited",
    Months:"months",
    Months3:"3 months",
    Months12:"12 months",
    Morning:"Morning",
    MultipleDominantPeriods:"Several dominant periods",
    MyGroup:"My group",
    Name: "Name",
    NameAlreadyUsed:"This name is already in use, please choose another one",
    NaturalDominantePeriodUsed:"The date with the most participants is used.",
    NewAdminPassword:"New admin password",
    NewSuffix:"new",
    NewUsersPassword:"New user password",
    NoAccountingRecordsFoundForThisGroup:"No accounting records found for this group.",
    NoActiveDays: "Close the current survey to create the menus and indicate the list of items to bring!",
    NoActiveDaysUser:"The survey must be closed by administrator before the menus can be created.",
    NoContactsYet: "Aucun contact n’a encore été ajouté à ce groupe.",
    NoCustomBlocksYet:"No custom blocks yet.",
    NoExpirationDefined:"No defined expiration date",
    NoGroupSelected: "No group selected",
    NoImagesSavedForThisGroup:"No images saved for this group",
    NoItemYet:"No articles at the moment",
    NoPeriodDefinedAddOrCreateOneToStart:"No set date range. Create, add, or edit dates to get started.",
    NoPeriodValidated:"No perid Validated",
    NoTheme: "No theme",
    Noon:"Noon",
    NoticeQuotaUsedAndGroupDeleted:"Your quota is used up and you have a deleted group",
    NotifyAdminOnSurveyFill:"Receive an email when all participants have voted (upcoming feature)",
    NoValidEmail:"No valid emails",
    NoValidEmailToCopy:"No emails to copy",
    NoValidPhone:"No valid number",
    NumberOf:"Number of ",
    NumberOfDays:"Number of day(s)",
    OktoGo:"Do you confirm?",
    OpenWhatsApp:"Open WhatsApp",
    OrganiZwk:"organiZwk, the app that helps you organize your event!",
    Organizers:"Organizers",
    Package3Months:"3-months package",
    Package6Months:"6-months package",
    Package12Months:"12-months package",
    PackageEssential:"Essential package",
    PackageRequired:"Package required",
    Package20Contacts:"Package of 20 contacts",
    PageListLinkSentError:"Error sending list link",
    PageListLinkSentSuccess:"List link sent successfully",
    Participants:"Participants",
    ParticipantsPerGroup:"Participant(s) per group",
    Participation:"+ I participate",
    Participate:"Participate",
    Party:"Location of the event",
    Password:"Password",
    PasswordsMustDiffer:"Passwords must be different.",
    PasswordReinit:"Password Reset",
    PasswordReset:"Passwords reset!",
    PasswordsSentToAdminEmail:"Password sent to organizer",
    PleaseWaitWakeUp: "Just a moment… I'm waking up 🥱",
    Payment1: "Payment 1",
    Payment2: "Payment 2",
    People:"People",
    Period: "Period: ",
    AuthorizedPeriods: "Authorized period(s)",
    Phone: "Phone",
    PhoneAlreadyUsed:"This phone number is used for another group, you can connect and pick up a ski pass.",
    PhonesAvailable: "valid number(s)",
    PhoneNumber:"Phone number",
    Plan: "Plan, Share, Enjoy",
    "PlanLabel.forfait3": "3-month package",
    "PlanLabel.forfait6": "6-month package",
    "PlanLabel.forfait12": "12-month package",
    "PlanLabel.essentiel": "Essential package",
    "PlanLabel.groupePlus1": "1 additional group",
    "PlanLabel.gratuit": "Free trial",
    PlanShareEnjoy:"Plan the event, share the shopping list, and enjoy the party with the organiZwk app 🍽️",
    PleaseEnterAGroupName:"Please enter a group name.",
    PleaseWaitBeforeSendingAgain:"Email(s) sent, please wait before resending.",
    Premium:"Premium",
    PremiumSubscription:"Premium Subscription",
    Print:"Print",
    PrintFor: "List for ",
    PrintThisDay:"The daily menus",
    Quantity:"Quantity",
    Qte: "Qty",
    QuantityRequired:"Please indicate a quantity",
    QuotaNotDefined:"Quota Not Defined",
    QuotaContactsReached: "Contact quota reached. Delete a contact or upgrade to a higher plan.",
    QuotaReached:"Your quota has been reached, you can choose to use another group or take out a package.",
    ReactivateExistingGroup:"Reactivate existing group",
    RealTime:"Real time",
    ReadRules:"See the rules",
    RecoverMyContacts:"Retrieve my contacts",
    RemoveLink:"Remove link",
    RGPDGeneralTerms:"General Terms and Conditions of Use (GTC) & GDPR Policy",
    RGPDAcceptUseConditions:"By using this application, you agree to these terms and conditions. This service is designed to facilitate group management, information sharing, and the organization of shared lists.",
    RGPD1PersonalDataProtection:"1. Protection of personal data (GDPR)",
    RGPDDataProtectionRegulationRules:"In accordance with the General Data Protection Regulation (GDPR), we only collect the data necessary for the creation and management of your group (name, email, telephone). This data is never resold and is stored securely.",
    RGPDPurposeCollection:"2. Purpose of the collection",
    RGPDDataUtilization:"The data is used to: create a group, manage access, send emails related to the lists, and allow personalization (emoji, color, etc.).",
    RGPDUsersRights:"3. User Rights",
    RGPDUsersContacts:"You can request access to, rectification of or deletion of your data at any time by contacting us via the address provided in the application.",
    RGPDResponsibility:"4. Responsibility",
    RGPDUsersResponsibility:"The user is responsible for the content they enter and share. The publisher cannot be held liable for any misuse or fraudulent use by a third party.",
    RGPD5Modifications:"5. Modifications",
    RGPDModificationschecks:"These Terms and Conditions may be updated at any time. Users are encouraged to review them regularly.",
    RowsPerPageShort:"Lines: ",
    SamePasswordWarning: "Administrator and user passwords must not be the same",
    Save:"Save",
    SaveImage:"Save image",
    SavePeriods: "Save periods",
    SavePeriodFailed:"Unable to save periods",
    SaltyItem:"Salty item",
    ScrollRight: "Scroll",
    SearchGroups:"Search for the group(s)",
    SearchContact: "Search for a contact...",
    SeeDemo:"See the demo",
    SeeReactivationOrSubscritpionOptions:"See reactivation options",
    selectLanguage: "Select language",
    SelectedPeriod:"selected date",
    SendMail: "Send an email",
    SendPageListLink:"Send the list by email",
    SendPasswordsByEmail:"Password reset link sent to administrator",
    SendShoppingListSMS:"Send the list via SMS",
    SendSMS: "SMS ", 
    SendSurveySMS:"Send the survey by SMS",
    SendSurveyEmail:"Send the survey by email",
    SeparateMultipleEmailsWithComma:"Separate emails with a comma",
    ServerError:"Server error.",
    SeveralPeriodsTied:"Several periods are tied. Choose the one to prioritize:",
    share: "Share",
    ShareListWhatsApp:"Send the list via WhatsApp",
    ShareSurveyWhatsApp:"Share the survey on WhatsApp",
    ShoppingList: "View and share the shopping list",
    ShowCards:"Cards",
    ShowTable:"Table",
    ShowColumnsFor: "Show columns for",
    SMSAppOpened: "SMS sent! Remember to provide the user password to the participants",
    SMSInvitationMessage: "Hello, \n\nThank you for completing the survey indicating the number of people attending on the proposed dates to determine an event date for the group ",
    ChoiceAdmin:"Create a group to invite participants or log in",
    SpecialPackagesAndGroups:"Special packages and groups",
    StartAdventure:"Create my group",
    Starter:"Starter",
    Statistics:"Statistics",
    SubscribeFor6Months:"Subscribe for 6 months",
    SubscribeFor1Year:"Subscribe for 1 year",
    Subscription:"Subscription",
    SubscriptionUpdated:"Your subscription has been updated. You can log in with the same password as before.",
    SubscriptionUpdatedWithDuration:"Your {{duration}} month(s) plan is active.",
    SubscriptionUpdatedWithDuration_one:"Your {{count}} month plan is active.",
    SubscriptionUpdatedWithDuration_other: "Your {{count}} months plan is active.",
    SURVEY: "2. SEND THE SURVEY",
    Survey: "Survey",
    SurveyAdmin: "SURVEY: Suggest dates and launch the survey",
    SurveyCompleted:"Closed survey",
    SurveyOpen: "Open survey",
    SurveyLocked:"Survey closed. Let's go to the menus!",
    SurveyLockedContactMessage:"The survey is closed. You can no longer add contacts.",
    SurveyLockedTooltip: "The survey is locked. It cannot be canceled.",
    SurveySuccessValidated:"Survey successfully validated, menus are created",
    SurveyUnvalidated:"Survey in progress...",
    SurveyUsers:"SURVEY: Scroll through the dates => and fill out the survey",
    SURVEYTAB: "SURVEY",
    SweetItem:"Sweet item",
    SyncActiveMessage:"The menus are updated automatically",
    Taken:"Taken",
    TelOptional:"Telephone (optional)",
    TestGroupMessage:"This group is a trial group. You can extend it for free for 1 month or choose another subscription.",
    Theme:"Theme",
    TheListIsreadyToBeSHared:"3. The shopping list is ready to be shared.",
    ThisActionWillDeleteMenusCreated:"This action will delete the menus created from the validated period!",
    ThisGroupUsesYourAdditionalQuota:"This Group Uses Your Additional Quota",
    TipContent:"Choose an emoji and a color to personalize the group!",
    TipTitle:"Tips",
    To: "to",
    Total:"Total",
    TotalVotes:"Total votes: ",
    TotalQuantityItems:"Total Items",
    Type: "Type",
    UnableToCreateGroup:"Unable to create group.",
    UpdateShoppingList:"Update the shopping list",
    UploadAnImage:"Choose an image:",
    UserPassword: "User password",
    UsersRole:"USERS vote on dates and contribute to the shopping list.",
    UnvalidateFailed:"Error during invalidation",
    UnvalidateSuccess:"Period successfully validated, menus are cleared",
    Validate:"Validate",
    ValidateEndOfSurvey:"Close survey",
    ValidPhoneNumber: "number to copy",
    ValidPhoneNumbers: "numbers",
    ValidUntil:"Valid until",
    ViewShoppingList:"See the shopping list",
    WhatsAppGroupName:"WhatsApp group name",  
    WhatsAppGroupLink:"WhatsApp invitation link", 
    WhatsAppGroupLinkIndication:"📱 On iPhone: open your WhatsApp group, tap the group name, then choose Add “Invite to join group via link” and “Copy link”.",
    WhatsAppSurveyGreeting: "Hello",
    WhatsAppSurveyInvitation: "Please vote to indicate your availability in the group {{nomGroupe}}. The password is:    ",  
    WhatsAppListInvitation: "Please indicate what you are contributing to the group list {{groupName}}. The password is:         ",
    Weblink:"web link",
    Welcome: "Welcome",
    welcomeToTheGroup: "Welcome to the group",
    What:"What",
    YouChooseSpecificPeriod:"Choice of date",
    Months3Event:"3 months event",
    Months12Event:"12 months event",
    YouHaveReachedYourQuota:"You have reached your quota.",   
    YourGroupWasDeleted:"Your previous group has been deleted",
  },
  es: {
    AdminDashboard:"Panel de administrador",
    AcceptCGUAndRGPD:"He leído y acepto los términos y condiciones y la política GDPR",
    Actions: "Acciones",
    ActiveGroups:"Grupos activos",
    ActivePeriod: "No hay período activo: cree uno.",
    Activity:"Actividad",
    ActivePlan:"Planes activos",
    Add: "Agregar",
    AddANewBlock:"Agregar un menú personalizado",
    AddAnItem:"Agregar un artículo",
    AddContact: "Agregar contacto",
    AddContactMsg: "Agregue contactos o pídales que se registren para las fechas propuestas.",
    Add5Contacts: "Agregar 5 contactos",
    Add5ContactsToGroup: "Agregar 5 contactos al grupo",
    AddCreator:"Añade al creador a los contactos",
    AddCreatorToContactsList:"Añade al creador a tu lista de contactos",
    AddOneGroupQuota: "Agregar un grupo adicional",
    AddPeriod:"Agregar un punto",
    AdminAndUserPasswordMustBeDifferent:"Las contraseñas de administrador y usuario deben ser diferentes",
    AdminMustChooseOne:"El administrador debe elegir un período",
    AdminNotificationDisabled:"Notificación por correo electrónico deshabilitada",
    AdminOnlyAction:"Acción reservada al administrador",
    AdminPassword: "Contraseña de administrador",
    AdminRole: "EL ORGANISADOR proporciona contactos, sugiere fechas y crea menús.",
    AdminWillBeNotified:"Notificación por correo electrónico habilitada",
    All:"Todo",
    AllowUsersToParticipate:"Permitir a los usuarios participar y modificar los menús.",
    NotAllowUsersToParticipate:"Los usuarios no pueden participar en los menús ni modificarlos..",
    AnImageIsAlreadySavedForThisGroup:"Ya hay una imagen guardada para este grupo.",
    Aperitif:"Aperitivo",
    ArticleRequired: "Artículo requerido",
    AverageLifespanOfTheGroups:"Esperanza de vida media de los grupos",
    Beverage:"Bebida",
    BlockDeleted: "Menú personalizado eliminado con éxito",
    BlocName:"Buzos para estación musical, servilletas...",
    BothDatesRequired:"Se requieren ambas fechas",
    Cancel: "Cancelar",
    CancelEndSurvey:"Cancelar cierre",
    CannotFixSurvey:"¡Agrega contactos para votar y cerrar la encuesta!",
    Category:"Categoría",
    Category_Sucré: "Dulce",
    Category_Salé: "Salado",
    Category_Boisson: "Bebida",
    Category_Apéro: "Aperitivo",
    Category_Entrée: "Entrante",
    Category_Plat: "Plato",
    Category_Dessert: "Postre",
    ChoiceAdmin:"Crea un grupo para invitar a participantes o iniciar sesión",
    ChooseFile:"Elige una imagen",
    ChooseThisOption: "Elige esta opción",
    ChooseWhatsAppGroupToVote:"Elige el grupo de WhatsApp para el mensaje de participación en la votación.",
    Close:"Cerca",
    CollapseAll:"Contraer todo",
    ComingSoon: "muy pronto",
    COMPTA: "CONTABILIDAD",
    ComptaAdmin:"CONTABILIDAD : Gestionar cuentas de alquiler",
    ComptaUsers:"CONTABILIDAD : Ver cuentas",
    Confirm:"Confirmar",
    ConfirmDeleteBlockText:"El menú personalizado desaparecerá de la lista de la compra.",
    ConfirmDeleteBlockTitle:"¿Confirma la eliminación de este menú personalizado?",
    ConfirmDeleteGroup: "Esta acción es irreversible y perderá el acceso a su grupo.", 
    ConfirmDeleteGroupTitle: "Confirmar la eliminación permanente del grupo y todos los datos",
    ConfirmDeleteSavedItem:"Eliminación del artículo",
    ConfirmDeleteTitle:"Confirmar eliminación",
    ConfirmEndOfSurvey:"Confirmar la finalización de la encuesta",
    ConfirmLockSurveyMessage:"Encuesta finalizada. ¡Vamos a los menús! ¿Deseas continuar?",
    ConfirmLockSurveyTitle:"Confirmar actualización de la lista de compras",
    ConfirmSurveyCancellation:"Confirmar cancelación del cierre de la encuesta",
    ConnectToAGroup:"Conéctate a un grupo",
    ConnectOrCreate:"Conéctate a un grupo o crea uno nuevo",
    ConsiderEntendingIt:"Considere la posibilidad de ampliarlo.",
    CONTACTS: "1. RELLENE LOS CONTACTOS",
    ContactAdded:" añadido!",
    ContactAdmin:"CONTACTOS: Agregar participantes, vincular mi grupo de WhatsApp o pedirles que se registren una vez que se propongan las fechas.",
    Contacts: "Contactos",
    ContactsDeleted:"Contactos eliminados",
    ContactUsers:"Ver la lista de participantes",
    CountryCode:"Código de país",
    CopyEmailAddress:"Copia la dirección de correo electrónico",
    CopyAllEmails:"Copiar los correos electrónicos",
    CopyEmails:"Copiar correos electrónicos del período dominante",
    CreatorAdded:"Creador agregado",
    CreatorAddFailed:"Error al agregar el creador",
    CreateANewGroup:"Crear un nuevo grupo",
    CreateNewGroup: "Crear nuevo grupo",
    CreateOrChooseAGroupToManageContacts: "Crea o elige un grupo para administrar contactos.",
    CreateWhatsAppGroup: "Crea el grupo de WhatsApp con los contactos de la cita ganadora",
    CreateYourMenus:"2. Crear los menús",
    Creation:"Creación",
    CreatorMail:"Correo electrónico del creador",
    CreatorTel: "Teléfono del creador",
    CurrentSubscription:"Suscripción actual: ",
    Date1: "Fecha 1",
    Date2: "Fecha 2",
    DailyMenu: "Menú diario",
    DayPerEvent:"Día(s) por evento",
    DayShort: "dia(s)",
    Del: "BORRAR",
    Delete: "Borrar",
    DeleteBlock:"Borrar el menú personalizado",
    DeleteGroup: "Delete Group", 
    DeleteGroupFailed:"No se pudo eliminar el grupo",
    DeleteImage:"Borrar imagen",
    DeleteItSoYouCanUploadANewOne:"Bórralo para poder cargar uno nuevo.",
    DeleteLast:"Eliminar la última",
    DeleteMenuFailed:"No se puede eliminar el menú asociado a este período",
    DemoVideo: "vídeo de demostración",
    Dessert:"Postre",
    Display: "Mostrar",
    DuplicateUserError:"Esta dirección de correo electrónico o número de teléfono ya está en uso para otro grupo; puedes elegir una suscripción.",
    Duration:"Duración",
    Email: "Correo electrónico",
    EmailAlreadyTaken:"Esta dirección de correo electrónico ya está en uso. Inicia sesión para suscribirte.",
    EmailsAvailable:"Correo(s) electrónico(s) válido(s)",
    EmailsAvailableToCopy: "correo(s) electrónico(s) para copiar",
    EmailsCopied:"Correos electrónicos copiados",
    EmailOptional:"Correo electrónico (opcional)",
    EmailSent:"¡Correo electrónico enviado! Recuerde proporcionar las contraseñas de usuario a los participantes.",
    EmojiTheme:"Tema de emojis",
    EmptyShoppingList: "Crea menús para llenar la lista de compras",
    EmptyInfosMapAdmin:"Añade un enlace web o una imagen para indicar la ubicación del evento.",
    EmptyInfosMapUser:"¡Próximamente se anunciará la ubicación del evento!",
    ErrorCopyingEmails:"Error al copiar correos electrónicos",
    ErrorDuringValidation:"Error durante la validación",
    ErrorLockingSurvey:"Error al bloquear",
    ErreurOccuredAddingContact: "Se produjo un error al agregar el contacto.",
    ErrorSendingEmail:"Error al enviar",
    EndDateAfterStart:"La fecha de finalización debe ser posterior a la fecha de inicio.",
    EnterEmailManually:"Introduzca la(s) dirección(es) de correo electrónico manualmente",
    EnterInformationToParticipateInSurvey:"Introduce tus datos para participar en la encuesta.",
    EnterWhatsAppGroupLink:"Introduce el enlace de invitación para tu grupo de WhatsApp.",
    Essential:"Esencial",
    EssentialSubscription:"Suscripción esencial",
    Evening:"Noche",
    ExistingGroup: "Este nombre de grupo ya está en uso. Elige otro.",
    ExpandAll:"Expandir todo",
    Extend:"Ampliar el grupo",
    ExtendContacts: "Aumentar el número de invitados",
    ExtendFor3MonthsFree:"Extiende tu prueba gratuita de 3 meses",
    ExtendOrAddAGroup:"Ampliar o agregar un grupo",
    Free:"Gratis",
    FreeGroups:"Grupos gratis",
    FreeGroupsActives:"Grupos libres activos",
    FreeGroupsInactives:"Grupos inactivos gratis",
    GoToMenus: "Ir a Menús",
    GoToSurvey: "Ir a la encuesta",
    GroupsOnly: "Groupos",
    GroupAlreadyUsedRGPD:"Grupo de prueba gratuito utilizado",
    Group1Contacts15:"1 groupo, 20 contactos",
    Group1Contacts20:"1 groupo, 20 contactos",
    Group1Contacts30:"1 groupo, 30 contactos",
    Group1Contacts30For12Months:"1 groupo, 30 contactos",
    Group5Contacts30Monthly:"Mensual, 5 groupos, 30 contactos",
    Group1Contacts20For12Months: "1 grupo, 20 contactos",
    GroupByOrganizer:"Grupo por organizador",
    GroupConnection:"Conexión de grupo",
    GroupeOneQuotaReached:"Cupo alcanzado: Ya has creado un grupo. Reactívalo o suscríbete.",
    GroupCreate: "Crear el grupo",
    GroupCreatedThisMonth:"Grupo creado este mes",
    GroupCreation: "Crear un grupo",
    GroupCreatedSuccessfully:"grupo creado exitosamente",
    GroupDeleted:"Grupo eliminado exitosamente",
    GroupDeletedOrFrozen:"El grupo ha sido utilizado y luego eliminado; puedes elegir otra suscripción.",
    GroupDelDashboard:"Grupos eliminados",
    GroupExpirationDate:"Este grupo expira el ",
    GroupExtensionFreeUsed:"Este grupo ya se ha beneficiado de una extensión gratuita. Cualquier extensión adicional requiere una suscripción.",
    GroupExtendedSuccessfully:"🎉 ¡Tu grupo se ha extendido!",
    GroupFreeTrialUsedWithThisEmail:"Ya has utilizado tu prueba gratuita. Por favor, amplíala o suscríbete.",
    GroupFromQuotaExtension:"Grupo de Extensión de Cuota",
    GroupModificationDesactivated:"La encuesta está cerrada - la edición del grupo está deshabilitada.",
    GroupName: "Nombre del grupo",
    GroupNameAlreadyUsed:"Este nombre ya está en uso. Elija otro.",
    GroupNameModificationImpossible:"No se puede cambiar el nombre del grupo",
    GroupNameALreadyInUse:"Este nombre de grupo ya está en uso.",
    GroupNumber:"grupo : ",
    GroupNotFound:"Grupo no encontrado",
    GroupOptions:"Opciones de grupo: ",
    GroupPerMonth:"Grupos por mes",
    GroupUpdated:"Grupo actualizado",
    Hide: "Esconder",
    Home: "Bienvenido",
    HowManyPeople: "Cuantas personas ?",
    IParticipate:"Yo participo",
    ImageDeleted:"Imagen eliminada",
    ImageSavedForGroup:"Imagen guardada para el grupo",
    ImportFromMobile: "Importar contactos desde el móvil",
    ImportContactsNotSupported:"Importación de contactos no admitida",
    ImportFromContacts:"Importar desde contactos",
    ImportFromMobile:"importar contactos desde el móvil",
    ImportYourContactsToSendTheSurvey:"1. Rellena los contactos para enviar la encuesta",
    ImpossibleAddParticipation:"No se pudo registrar tu participación. Ponte en contacto con el administrador del grupo.",
    IncorrectNameOrPassword: "Nombre de grupo o contraseña incorrectos",
    Identifier:"Identificador",
    Information:"Información",
    InfosAdmin:"UBICACIÓN DEL EVENTO: Agregue una foto o un enlace a la ubicación del evento",
    InfosMap:"Ubicación del evento",
    InfosUsers:"UBICACIÓN DEL EVENTO",
    IntroFree:"Extiende tu período de prueba gratis",
    Intro3Months:"Para una velada con amigos...",
    Intro6Months:"Un cumpleaños, una despedida de soltera...",
    Intro12Months:"¡Una reunión familiar, una celebración familiar ?!",
    IntroEssential:"Para los genios de la organización: ¡5 grupos al mismo tiempo!",
    IntroGroupPlus1: "Agrega un grupo adicional con 30 contactos.",
    Intro20Contacts: "¿Una salida, un cumpleaños, una celebración familiar? ¡Vamos!",
    IntroAdd10Contacts:"Agregar invitados",
    IntroAdd5Contacts:"Agregar 5 invitados",
    InvalidEmailFormat:"Formato de correo electrónico no válido",
    InvalidPhone: "Número de teléfono inválido. Use el formato internacional (+XX...)",
    InvalidPhoneFormat:"Formato de número de teléfono no válido",
    Item:"Artículo",
    ItemAlreadyExists:"El artículo ya existe.",
    ItemCreated: "Artículo creado",
    ItemDeleted:"Artículo eliminado",
    ItemRequired: "Artículo requerido",
    LandingTitle:"OrganiZwk - Organiza tus fines de semana fácilmente",
    LandingDescription:"¡Crea tu grupo, sugiere fechas, planifica los menús y comparte la lista!",
    LandingSEO_Title:"OrganiZwk – Organiza fácilmente tus fiestas, fines de semana y eventos",
    LandingSEO_Description: "OrganiZwk hace que organizar tus eventos sea más fácil: gestiona contactos, elige la fecha, crea menús, lista los artículos a llevar y centraliza toda la información.",
    LastNameFirstName:"Apellido Nombre",
    LinkSavedSuccess:"Enlace guardado exitosamente",
    LIST: "4. COMPARTE LA LISTA DE LA COMPRA",
    List: "Lista de compras",
    LinkDeletedSuccess:"Enlace eliminado exitosamente",
    LinkWhatsAppGroup:"Vincular mi grupo de whatsapp",
    LinkSaved:"Enlace guardado",
    ListeAdmin:"LISTA DE COMPRAS : Enviar la lista a los participantes",
    ListeUsers:"LISTE DE COMPRAS : Completa la lista de compras",
    EmptyListeUsersMsg:"La lista de la compra se genera automáticamente en función de los menús.",
    locale: "es-ES" ,
    Loading: "Cargando...",
    LogIn: "Acceso",
    LogOut:"Finalizar la sesión",
    MainCourses:"Plato principal",
    ManageYourGuests: "Importa y administra tus invitados",
    MaxPeriodExceeded:"El período no debe exceder de 7 días.",
    MENUS: "3. CREAR MENÚS",
    Menus: "Menús",
    MenuUpdated: "Menú actualizado",
    Matin: "Mañana", 
    Midi: "Mediodía", 
    Soir: "Noche", 
    Sucré: "Dulce", 
    Salé: "Salado", 
    Boisson: "Bebida", 
    Apéro: "Aperitivo", 
    Entrée: "Entrada", 
    Plat: "Plato principal", 
    Dessert: "Postre",
    MailAddrCopied:"Dirección de correo electrónico copiada ✓",
    MaxParticipantsReached:"Se ha alcanzado el número máximo de participantes. Por favor, contacte con el administrador del grupo.",
    MenusAdmin:"MENÚS: ¡Crea menús para cada día",
    MenuCreationFollowingWinningDates : "Creación de menús. ",
    MenusUsers:"LOS MENÚS : Menús diarios",
    ModifyGroupName: "Cambiar el nombre del grupo",
    ModifyPeriod: "Crear, agregar, modificar fechas",
    Moment_Matin: "Mañana",
    Moment_Midi: "Mediodía",
    Moment_Soir: "Noche",
    Monthly:"mensual",
    MonthlyUnlimited:"Mensual ilimitado",
    Months:"meses",
    Months3:"3 meses",
    Months12:"12 meses",
    Morning:"Mañana",
    MultipleDominantPeriods:"Varios períodos dominantes",
    MyGroup:"Mi groupo",
    Name: "apellido",
    NameAlreadyUsed:"Este nombre ya está en uso, por favor elija otro",
    NaturalDominantePeriodUsed:"Se utiliza la fecha con más participantes.",
    NewAdminPassword:"Nueva contraseña de administrador",
    NewGroup20Contacts:"Nuevo grupo con 20 contactos",
    NewSuffix:"nuevo",
    NewUsersPassword:"Nueva contraseña de usuario",
    NoAccountingRecordsFoundForThisGroup:"No se encontraron registros contables para este grupo.",
    NoActiveDays: "¡Cierra la encuesta actual para crear los menús e indica la lista de artículos que debes traer!",
    NoActiveDaysUser:"El administrador debe cerrar la encuesta antes de que se puedan crear los menús.",
    NoCustomBlocksYet:"Aún no hay bloques personalizados.",
    NoExpirationDefined:"Sin fecha de vencimiento definida",
    NoGroupSelected: "Ningún grupo seleccionado",
    NoImagesSavedForThisGroup:"No hay imágenes guardadas para este grupo.",
    NoItemYet:"No hay artículos en este momento",
    NoPeriodDefinedAddOrCreateOneToStart:"No hay un rango de fechas establecido. Crea, añade o edita fechas para empezar.",
    NoTheme: "Sin tema",
    NoticeQuotaUsedAndGroupDeleted:"Tu cuota se ha agotado y tienes un grupo eliminado",
    NoPeriodValidated:"Ningún periodo validado",
    Noon:"Mediodía",
    NotifyAdminOnSurveyFill:"Recibir un correo electrónico cuando todos los participantes hayan votado (próxima característica)",
    NoValidEmail:"ningún correo electrónico válido",
    NoValidEmailToCopy:"No hay correos electrónicos para copiar",
    NoValidPhone:"Ningún número válido",
    NumberOf:"Número de ",
    NumberOfDays:"Número de día(s)",
    OktoGo:"¿Confirmas? ",
    OpenWhatsApp:"Abrir WhatsApp",
    Organizers:"Organizadores",
    OrganiZwk:"organiZwk, ¡la app que te ayuda a organizar tu evento!",
    PageListLinkSentError:"Error al enviar el enlace de la lista",
    Package3Months:"Paquete de 3 meses",
    Package6Months:"Paquete de 6 meses",
    Package12Months:"Paquete de 12 meses",
    PackageEssential:"Paquete esencial",
    PackageRequired:"Paquete requerido",
    Package20Contacts:"Paquete de 20 contactos",
    PageListLinkSentSuccess:"Enlace de lista enviado correctamente",
    Participants:"Participantes",
    ParticipantsPerGroup:"Participantes por grupo",
    Participation:"+ yo participo",
    Participate:"Participar",
    Party:"Ubicación del evento",
    Password:"Contraseña",
    PasswordsMustDiffer:"Las contraseñas deben ser diferentes.",
    PasswordReset:"¡Restablecer contraseñas!",
    PasswordReinit:"Restablecer contraseña",
    PasswordsSentToAdminEmail:"Contraseña enviada al organizador",
    PleaseWaitWakeUp: "Un momento… estoy despertando 🥱",
    Payment1: "Pago 1",
    Payment2: "Pago 2",
    People:"Personas",
    Period: "Período: ",
    AuthorizedPeriods: "Período(s) autorizado(s)",
    Phone: "Teléfono",
    PhoneAlreadyUsed:"Este número de teléfono se utiliza para otro grupo, puedes conectarte y elegir un complemento",
    PhonesAvailable: "número(s) válido(s)",
    PhoneNumber:"Número de teléfono",
    Plan: "Planifica, comparte, disfruta",
    "PlanLabel.forfait3": "Paquete de 3 meses",
    "PlanLabel.forfait6": "Paquete de 6 meses",
    "PlanLabel.forfait12": "Paquete de 12 meses",
    "PlanLabel.essentiel": "Fórmula esencial",
    "PlanLabel.groupePlus1": "1 grupo adicional",
    "PlanLabel.gratuit": "Prueba gratuita",
    PlanShareEnjoy:"Planifica el evento, comparte la lista de compras y disfruta de la fiesta con la aplicación organiZwk 🍽️",
    PleaseEnterAGroupName:"Ingrese un nombre para el grupo.",
    PleaseWaitBeforeSendingAgain:"Correo(s) electrónico(s) enviado(s), por favor espere antes de volver a enviar.",
    Premium:"Premium",
    PremiumSubscription:"Suscripción Premium",
    Print:"Imprimir",
    PrintFor: "Lista para ",
    PrintThisDay:"Los menús diarios",
    Quantity:"Cantidad",
    Qte: "Cantidad",
    QuantityRequired:"Por favor indique una cantidad",
    QuotaNotDefined:"Cuota no definido",
    QuotaContactsReached: "Se ha alcanzado el límite de contactos. Elimine un contacto o actualice a un plan superior.",
    QuotaReached:"Tu cupo ha sido alcanzado, puedes optar por utilizar otro grupo o contratar un paquete.",
    ReactivateExistingGroup:"Reactivar grupo existente",
    RealTime:"Tiempo real",
    ReadRules:"Ver las reglas",
    RecoverMyContacts:"Recuperar mis contactos",
    RemoveLink:"Quitar enlace",
    RGPDGeneralTerms:"Condiciones Generales de Uso (CGV) y Política del RGPD",
    RGPDAcceptUseConditions:"Al usar esta aplicación, aceptas estos términos y condiciones. Este servicio está diseñado para facilitar la gestión de grupos, el intercambio de información y la organización de listas compartidas.",
    RGPD1PersonalDataProtection:"1. Protección de datos personales (RGPD)",
    RGPDPurposeCollection:"2. Finalidad de la colección",
    RGPDDataUtilization:"Los datos se utilizan para: crear un grupo, gestionar el acceso, enviar correos electrónicos relacionados con las listas y permitir la personalización (emoji, color, etc.).",
    RGPDUsersRights:"3. Derechos del usuario",
    RGPDUsersContacts:"Podrás solicitar el acceso, rectificación o supresión de tus datos en cualquier momento contactándonos a través de la dirección facilitada en la aplicación.",
    RGPDResponsibility:"4. Responsabilidad",
    RGPDUsersResponsibility:"El usuario es responsable del contenido que introduce y comparte. El editor no se responsabiliza del uso indebido o fraudulento por parte de terceros.",
    RGPD5Modifications:"5. Modificaciones",
    RGPDModificationschecks:"Estos Términos y Condiciones pueden actualizarse en cualquier momento. Se recomienda a los usuarios que los revisen periódicamente.",
    RGPDDataProtectionRegulationRules:"De acuerdo con el Reglamento General de Protección de Datos (RGPD), solo recopilamos los datos necesarios para la creación y gestión de su grupo (nombre, correo electrónico, teléfono). Estos datos nunca se revenden y se almacenan de forma segura.",
    RowsPerPageShort:"Líneas: ",
    SamePasswordWarning: "Las contraseñas de administrador y usuario no deben ser las mismas",
    Save:"Ahorrar",
    SaveImage:"Salvar el imagen",
    SavePeriods: "Guardar periodos",
    SavePeriodFailed:"No se pueden guardar los periodos",
    SaltyItem:"artículo salado",
    ScrollRight: "Voluta",
    SearchContact: "Buscar un contacto...",
    SearchGroups:"Buscar el grupo(s)",
    SeeDemo:"Ver la demostración",
    SeeReactivationOrSubscritpionOptions:"Ver opciones de reactivación",
    selectLanguage: "Seleccionar idioma",
    SelectedPeriod: "Fecha seleccionada",
    SendMail: "enviar un correo electrónico",
    SendPageListLink:"Enviar la lista por correo electrónico",
    SendPasswordsByEmail:"Enlace de restablecimiento de contraseña enviado al administrador",
    SendShoppingListSMS:"Enviar la lista por SMS",
    SendSurveySMS:"Enviar la encuesta por SMS",
    SendSurveyEmail:"Enviar la encuesta por correo electrónico",
    SendSMS: "mensaje de texto ", 
    SeparateMultipleEmailsWithComma:"Separe los correos electrónicos con una coma",
    ServerError:"Error del servidor.",
    SeveralPeriodsTied:"Hay varios periodos empatados. Elige el que priorices:",
    SMSAppOpened: "¡SMS enviado! Recuerda proporcionar la contraseña de usuario a los participantes.",
    SMSInvitationMessage: "Hola, \n\nGracias por completar la encuesta indicando el número de personas que asistirán en las fechas propuestas para determinar una fecha de evento para el grupo",
    share: "Compartir",
    ShareListWhatsApp:"Envía la lista vía WhatsApp",
    ShareSurveyWhatsApp:"Comparte la encuesta en WhatsApp",
    ShoppingList: "Ver y compartir la lista de compras",
    ShowCards:"Tarjetas",
    ShowTable:"Mesa",
    ShowColumnsFor: "Mostrar columnas para",
    SpecialPackagesAndGroups:"Paquetes especiales y grupos.",
    StartAdventure:"crear mi grupo",
    Starter:"Entrante",
    Statistics:"Estadística",
    SubscribeFor6Months:"Suscríbete por 6 meses",
    SubscribeFor1Year:"Suscríbete por 1 año",
    Subscription:"Suscripción",
    SubscriptionUpdated:"Tu suscripción se ha actualizado. Puedes iniciar sesión con la misma contraseña de antes.",
    SubscriptionUpdatedWithDuration:"Tu plan de {{duration}} mese(s) está activo.",
    SubscriptionUpdatedWithDuration_one:"Tu plan de {{count}} meses está activo.",
    SubscriptionUpdatedWithDuration_other: "Tu plan de {{count}} meses está activo.",
    SURVEY: "2. ENVÍE LA ENCUESTA",
    Survey: "Encuesta",
    SurveyAdmin: "ENCUESTA: Sugiera fechas y lance la encuesta.",
    SurveyCompleted:"Encuesta cerrada",
    SurveyOpen: "Encuesta abierta",
    SurveyLocked:"Encuesta cerrada. ¡Vamos a los menús!",
    SurveyLockedContactMessage:"La encuesta ha finalizado. Ya no puedes añadir contactos.",
    SurveyLockedTooltip: "La encuesta está bloqueada. No se puede cancelar.",
    SurveySuccessValidated:"Encuesta validada exitosamente, menús creados",
    SurveyUnvalidated:"Encuesta en progreso...",
    SurveyUsers:"ENCUESTA: Desplácese por las fechas => y complete la encuesta.",
    SURVEYTAB: "ENCUESTA",
    SweetItem:"dulce artículo",
    SyncActiveMessage:"Los menús se actualizan automáticamente.",
    Taken:"Tomado",
    TelOptional:"Teléfono (opcional)",
    TestGroupMessage:"Este grupo es un grupo de prueba. Puedes extenderlo gratis por 1 mes o elegir otro suscripción.",
    Theme:"Tema",
    TheListIsreadyToBeSHared:"3. ¡Y ya está! La lista de compras está lista para ser compartida.",
    ThisActionWillDeleteMenusCreated:"¡Esta acción eliminará los menús creados a partir del período validado!",
    ThisGroupUsesYourAdditionalQuota:"Este grupo utiliza su cuota adicional",
    TipContent:"¡Elige un emoji y un color para personalizar el grupo!",
    TipTitle:"Consejos",
    To: "al",
    Total:"Total",
    TotalVotes:"Votos totales: ",
    TotalQuantityItems:"Artículos totales",
    Type: "Tipo",
    UpdateShoppingList:"Actualizar la lista de compras",
    UploadAnImage:"Elige una imagen:",
    UserPassword: "Contraseña de usuario",
    UsersRole:"LOS USUARIOS votan las fechas y contribuyen a la lista de compras.",
    UnableToCreateGroup:"No se puede crear el grupo.",
    UnvalidateFailed:"Error durante la invalidación",
    UnvalidateSuccess:"Periodo validado exitosamente, los menús están borrados",
    Validate:"Validar",
    ValidateEndOfSurvey:"Cerrar encuesta",
    ValidPhoneNumber: "número para copiar",
    ValidPhoneNumbers: "números",
    ValidUntil:"Válido hasta",
    ViewShoppingList:"Ver la lista de compras",
    WhatsAppGroupName:"Nombre del grupo whatsapp", 
    WhatsAppGroupLink:"Enlace de invitación whatsapp",  
    WhatsAppGroupLinkIndication:"📱 En iPhone: abre tu grupo de WhatsApp, toca el nombre del grupo y luego elige Agregar “Invitar a unirse al grupo a través de un enlace” y “Copiar enlace”.", 
    WhatsAppSurveyGreeting: "Hola",
    WhatsAppSurveyInvitation: "Por favor, vote para indicar su disponibilidad en el grupo. {{nomGroupe}}. La contraseña es:     ", 
    WhatsAppListInvitation: "Por favor, indique qué aporta a la lista de grupo {{groupName}}. La contraseña es:        ",
    Weblink:"enlace web",
    Welcome: "Bienvenido",
    welcomeToTheGroup: "Bienvenido al grupo",
    What:"Qué",
    YouChooseSpecificPeriod:"Elección de fecha",
    Months3Event:"evento de 3 meses",
    Months12Event:"evento de 12 meses",
    YouHaveReachedYourQuota:"Has alcanzado tu cuota.",  
    YourGroupWasDeleted:"Tu grupo anterior ha sido eliminado",
  },
};

